import { useEffect, useState } from "react";
import axios from "axios";
import { MessageCircle } from "lucide-react";
import { SOCIALS } from "@/constants/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WhatsAppFloat = () => {
  const [href, setHref] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/config`)
      .then((r) => setHref(r.data.whatsapp_number ? `https://wa.me/${r.data.whatsapp_number}?text=${encodeURIComponent("Hi Akki! Website se aa raha hoon — baat karni hai.")}` : SOCIALS.instagram))
      .catch(() => setHref(SOCIALS.instagram));
  }, []);

  if (!href) return null;

  return (
    <a
      data-testid="whatsapp-float"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-[60] w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_15px_40px_-8px_rgba(37,211,102,0.5)] hover:scale-110 transition-transform duration-300"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
      <MessageCircle size={24} className="relative" />
    </a>
  );
};